module.exports = __webpack_public_path__ + "img/exhibitimgar.e3bbc30d.png";